module.exports = __webpack_public_path__ + "media/images/writer/monitor/ico-about-d18ae089458bf531d43b560be5f7a16e.svg";